import { useMemo, useSyncExternalStore, type ReactNode } from 'react'

import { LoadingContext } from './LoadingContext'
import type { LoadingContextValue, LoadingStore } from './types'

interface LoadingProviderProps {
  store: LoadingStore
  children?: ReactNode
}

export function LoadingProvider({ children, store }: LoadingProviderProps) {
  const snapshot = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot)

  const value = useMemo<LoadingContextValue>(
    () => ({
      ...snapshot,
      startLoading: store.startLoading,
      stopLoading: store.stopLoading,
      withLoading: store.withLoading,
    }),
    [snapshot, store]
  )

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
}
